import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
const supabaseServiceRoleKey = process.env.REACT_APP_SUPABASE_SERVICE_ROLE_KEY;

if (!supabaseUrl || !supabaseServiceRoleKey || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables. Check your .env file.');
}

// 싱글턴: 로그인용 클라이언트 (anon key)
let _supabaseAuth = null;
const getSupabaseAuth = () => {
  if (!_supabaseAuth) {
    _supabaseAuth = createClient(supabaseUrl, supabaseAnonKey);
  }
  return _supabaseAuth;
};

// 싱글턴: 데이터 조회용 클라이언트 (service_role key - RLS 무시)
let _supabase = null;
export const getSupabase = () => {
  if (!_supabase) {
    _supabase = createClient(supabaseUrl, supabaseServiceRoleKey, {
      auth: {
        autoRefreshToken: false,
        persistSession: false
      }
    });
  }
  return _supabase;
};

export const supabase = getSupabase();

// 환경변수에서 관리자 계정 정보 로드
const ADMIN_EMAIL = process.env.REACT_APP_ADMIN_EMAIL;
const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;

export const signInAdmin = async (username, password) => {
  // username이 "admin"이면 환경변수의 이메일로 변환
  const email = username === 'admin' ? ADMIN_EMAIL : username;

  // 1. 먼저 하드코딩된 비밀번호와 비교 (빠른 체크)
  if (email === ADMIN_EMAIL && password === ADMIN_PASSWORD) {
    // 로컬 인증 성공
    localStorage.setItem('admin_authenticated', 'true');
    localStorage.setItem('admin_user', username);
    return { user: { email: username } };
  }

  // 2. Supabase Auth로도 시도 (나중에 Auth 사용하려면)
  try {
    const { data, error } = await getSupabaseAuth().auth.signInWithPassword({
      email,
      password,
    });

    if (error) throw error;

    // 관리자 이메일 체크
    if (data.user.email === ADMIN_EMAIL) {
      localStorage.setItem('admin_authenticated', 'true');
      localStorage.setItem('admin_user', username);
      return data;
    }

    await getSupabaseAuth().auth.signOut();
    throw new Error('관리자 계정이 아닙니다.');
  } catch (authError) {
    // Auth 실패 시 환경변수 체크
    throw new Error('아이디 또는 비밀번호가 일치하지 않습니다.');
  }
};

// Sign out
export const signOut = async () => {
  localStorage.removeItem('admin_authenticated');
  localStorage.removeItem('admin_user');
};

// Get current session
export const getSession = async () => {
  const isAuthenticated = localStorage.getItem('admin_authenticated') === 'true';
  const username = localStorage.getItem('admin_user');

  if (isAuthenticated && username) {
    return { user: { email: username } };
  }

  return null;
};

// Listen to auth changes (dummy)
export const onAuthStateChange = (callback) => {
  return { data: { subscription: { unsubscribe: () => {} } } };
};
